import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EmailHtmlEditorComponent } from './email-html-editor.component';
import { NgxEditorModule } from 'ngx-editor';
import { IncludeDetailsCheckboxesModule } from '../include-details-checkboxes/include-details-checkboxes.module';

@NgModule({
  declarations: [EmailHtmlEditorComponent],
  imports: [CommonModule, FormsModule, NgxEditorModule, IncludeDetailsCheckboxesModule],
  exports: [EmailHtmlEditorComponent, IncludeDetailsCheckboxesModule ],
  entryComponents: [EmailHtmlEditorComponent],
})
export class EmailHtmlEditorModule {}
